import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore/lite";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDVy7THK9jYSqYukGIb0mUT3qG5x-lJJjU",
  authDomain: "pec-eip-6ce4f.firebaseapp.com",
  projectId: "pec-eip-6ce4f",
  storageBucket: "pec-eip-6ce4f.appspot.com",
  messagingSenderId: "798259915342",
  appId: "1:798259915342:web:1e790aca639d73d23b311f",
  measurementId: "G-41SYQKFTVT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

const realtimeDb = getDatabase();

const storage = getStorage();

export { app, db, realtimeDb, storage };
